import { useSelector } from "react-redux";
import { BarkioOnly, BibinoOnly } from "src/utils/environment";
import getImageSrc from "src/utils/getImageSrc";
import { getYoungestAvatar } from "src/modules/avatar/duck/selectors";
import BabyLottieAnimation from "src/modules/avatar/components/BabyLottieAnimation";
import { Image, Flex } from "@chakra-ui/react";

// width = ["210px", "294px", "315px"]
function LogoAvatar({ width = "40vmin" }) {
  const avatar = useSelector(getYoungestAvatar);
  return (
    <>
      <Flex alignItems="center" justifyContent="center" width={width} minW="120px" minH="153px">
        <BibinoOnly
          sex={avatar?.sex}
          {...avatar?.avatarCustomization}
          skinColor={avatar?.avatarCustomization?.skinColor || avatar?.moreDataJson?.skinColor}
          animationName="main-logo.json"
        >
          {BabyLottieAnimation}
        </BibinoOnly>
        <BarkioOnly src={getImageSrc("main-logo.svg")} objectFit="cover" width="100%">
          {Image}
        </BarkioOnly>
      </Flex>
    </>
  );
}

export default LogoAvatar;
